module.exports = __webpack_public_path__ + "img/Relationship.0e7def55.svg";